import { GET_LEAD_ASSIGNATION_LOGS } from "../constants";
import Requests from "../requests";

const LeadAssignationLogService = {
    getRecentLeadAssignationLogs() {
        return Requests.getWithAuth(GET_LEAD_ASSIGNATION_LOGS);
    }
}

export default LeadAssignationLogService;
